<template>
  <!-- 抽屉 -->
  <a-drawer
    title="任务项目"
    :width="720"
    :visible="visible"
    :bodyStyle="bodyStyle"
    @close="onClose"
  >
    <!-- 内容 -->
    <div class="drawer-content">
      <!-- 信息 -->
      <div class="detail-info">
        <!-- 任务ID -->
        <a-row class="detail-row">
          <a-col :span="5" class="detail-title">任务ID：</a-col>
          <a-col :span="19">{{ detail.number }}</a-col>
        </a-row>
        <!-- 任务名称 -->
        <a-row class="detail-row">
          <a-col :span="5" class="detail-title">任务名称：</a-col>
          <a-col :span="19">{{ detail.task_name }}</a-col>
        </a-row>
        <!-- 项目ID -->
        <a-row class="detail-row">
          <a-col :span="5" class="detail-title">项目ID：</a-col>
          <a-col :span="19">{{ detail.project_id }}</a-col>
        </a-row>
        <!-- 归属项目 -->
        <a-row class="detail-row">
          <a-col :span="5" class="detail-title">归属项目：</a-col>
          <a-col :span="19">{{ detail.project_name }}</a-col>
        </a-row>
        <!-- 业务类型 -->
        <a-row class="detail-row">
          <a-col :span="5" class="detail-title">业务类型：</a-col>
          <a-col :span="19">{{ detail.business_type_name }}</a-col>
        </a-row>
        <!-- 发布人 -->
        <a-row class="detail-row">
          <a-col :span="5" class="detail-title">发布人：</a-col>
          <a-col :span="19">{{ detail.lg_username }}</a-col>
        </a-row>
        <!-- 承接方式 -->
        <a-row class="detail-row">
          <a-col :span="5" class="detail-title">承接方式：</a-col>
          <a-col :span="19" v-if="detail.accpet_type === 1">指定承接人</a-col>
          <a-col :span="19" v-if="detail.accpet_type === 2">委托平台指派</a-col>
        </a-row>
        <!-- 服务商 -->
        <a-row class="detail-row" v-if="detail.supplier_name">
          <a-col :span="5" class="detail-title">服务商：</a-col>
          <a-col :span="19">{{ detail.supplier_name }}</a-col>
        </a-row>
        <!-- 承接人 -->
        <a-row class="detail-row">
          <a-col :span="5" class="detail-title">承接人：</a-col>
          <a-col :span="19">{{ (detail.taskUserNames || []).join('、') }}</a-col>
        </a-row>
        <!-- 任务金额 -->
        <a-row class="detail-row">
          <a-col :span="5" class="detail-title">任务金额：</a-col>
          <a-col :span="19">{{ detail.money || 0 }}元</a-col>
        </a-row>
        <!-- 服务费率 -->
        <a-row class="detail-row">
          <a-col :span="5" class="detail-title">服务费率：</a-col>
          <a-col :span="19">{{ detail.fax || 0 }}%</a-col>
        </a-row>
        <!-- 服务费 -->
        <a-row class="detail-row">
          <a-col :span="5" class="detail-title">服务费：</a-col>
          <a-col :span="19">{{ detail.total_fee_money || 0 }}元</a-col>
        </a-row>
        <!-- 服务费承担人 -->
        <a-row class="detail-row">
          <a-col :span="5" class="detail-title">服务费承担人：</a-col>
          <a-col :span="19" v-if="detail.fee_pay_type === 1">付款人</a-col>
          <a-col :span="19" v-if="detail.fee_pay_type === 2">收款人</a-col>
        </a-row>
        <!-- 实际支出 -->
        <a-row class="detail-row">
          <a-col :span="5" class="detail-title">实际支出：</a-col>
          <a-col :span="19">{{ detail.pay_money || 0 }}元</a-col>
        </a-row>
        <!-- 承接人到账 -->
        <a-row class="detail-row">
          <a-col :span="5" class="detail-title">承接人到账：</a-col>
          <a-col :span="19">{{ detail.taskUserMoney || 0 }}元</a-col>
        </a-row>
        <!-- 交付日期 -->
        <a-row class="detail-row">
          <a-col :span="5" class="detail-title">交付日期：</a-col>
          <a-col :span="19">{{ detail.end_time }}</a-col>
        </a-row>
        <!-- 验收方式 -->
        <a-row class="detail-row">
          <a-col :span="5" class="detail-title">验收方式：</a-col>
          <a-col :span="19">线下验收</a-col>
        </a-row>
      </div>
      <!-- 记录 -->
      <div class="detail-record">
        <!-- 操作记录 -->
        <div class="record-item" v-for="item in (detail.task_record || [])" :key="item.id">
          <!-- icon -->
          <a-icon type="history" />
          <!-- 时间 -->
          <span style="margin-left: 6px; white-space: nowrap">{{ item.created_at }}</span>
          <!--  -->
          <div class="record-content">{{ item.reamrk }}</div>
        </div>
      </div>
    </div>
    <!-- 确定取消 -->
    <div class="detail-footer">
      <!-- 任务状态 -->
      <div class="detail-status">
        <a-badge status="success" />任务已完成
      </div>
      <!-- 弹簧 -->
      <div style="flex: 1;"></div>
      <!-- 操作 -->
      <!-- <a-button class="detail-cancel" @click="onClose">取 消</a-button> -->
      <!-- <a-button type="primary" @click="onCommit">确 定</a-button> -->
    </div>
    <!-- 进度条 -->
    <Loading :loading="isLoading"></Loading>
  </a-drawer>
</template>

<script>
import Pub from '@/utils/public'
import Loading from '@/components/Loading'
import { getTaskDetail } from '@/api/request'
export default {
  components: {
    Loading
  },
  data () {
    return {
      // 显示/加载
      visible: false,
      isLoading: false,
      // 样式
      bodyStyle: {
        padding: '0px'
      },
      // 任务ID
      taskID: undefined,
      // 任务详情
      detail: {}
    }
  },
  methods: {
    // 显示
    showDrawer (id) {
      this.taskID = id
      this.detail = {}
      this.visible = true
      this.getTaskDetail()
    },
    // 关闭
    onClose () {
      if (!this.isLoading) {
        this.visible = false
      }
    },
    // 提交
    onCommit () {
      console.log('提交')
    },
    // 获取任务详情
    getTaskDetail () {
      this.isLoading = true
      const params = {
        id: this.taskID,
      }
      getTaskDetail(params).then(res => {
        this.isLoading = false
        const { code, data, message } = res
        if (code === 0) {
          this.detail = data
          const taskUsers = this.detail.task_user || []
          const taskUserNames = []
          var taskUserMoney = 0
          taskUsers.forEach(item => {
            taskUserNames.push(item.hepai_username)
            taskUserMoney += Number(item.get_money || 0)
          })
          this.detail.taskUserNames = taskUserNames
          this.detail.taskUserMoney = Pub.KEEP_NUMBER_DECIMAL(taskUserMoney, 2, false, true)
        } else {
          this.$message.error(message)
        }
      }).catch(() => {
        this.isLoading = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
.drawer-content {
  padding-bottom: 46px;
}
.detail-footer {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background-color: #fff;
  display: flex;
  align-items: center;
}
.detail-cancel {
  margin-right: 15px;
}
.detail-row {
  margin-bottom: 24px;
}
.detail-row:first-child {
  margin-top: 24px;
}
.detail-title {
  text-align: right;
  color: rgba(0, 0, 0, 0.85);
}
.detail-record {
  border-top: 1px solid #EBEBEB;
  height: 230px;
  overflow-y: auto;
}
.record-item {
  padding: 0 24px;
  display: flex;
  align-items: center;
  color: rgba(0, 0, 0, 0.4);
  margin-bottom: 16px;
}
.record-item:first-child {
  margin-top: 16px;
}
.record-content {
  max-width: 460px;
  margin-left: 24px;
  word-break: break-all;
}
</style>